import React, {PureComponent} from 'react';
import invoke from 'lodash.invoke';
import cx from 'classnames';

/**
 * SearchResultItem -> wrapper component to display current selected index mouse and keyboard interactions
 * @param active
 * @param children
 * @return {*}
 * @constructor
 */
class SearchResultItem extends PureComponent {

    handleMouseEnter = ( evt ) => {
        invoke( this.props, 'onResultHover', evt, this.props )
    };

    handleClick = ( evt ) => {
        invoke( this.props, 'onResultClick', evt, this.props )
    };

    render () {
        const {index, active, activeClass = '', children, onResultHover, onResultClick, className, style = {}, ...rest} = this.props;
        const itemClasses = cx(
            't-transform t-duration-short',
            className,
            {[activeClass]: active}
        );

        // console.log( `[SearchResultItem] #${index}` )
        return (
            <div id={`search-result-item-${index}`}
                 data-testid="search-result-item"
                 style={style}
                 onMouseEnter={this.handleMouseEnter}
                 onClick={this.handleClick}
                 className={itemClasses}
                 {...rest}>
                {children}
            </div>
        );
    }
}

export default SearchResultItem;
